import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'rogueCaseAction'
})
export class RogueCaseActionPipe implements PipeTransform {

  transform(value: string | null | undefined): unknown {
    switch (value) {
      case 'SCRAP':
        return 'Scrap';
      case 'REHAB':
        return 'Rehab';
      case 'ACCEPT':
        return 'Accept';
      case 'EXCHANGE':
        return 'Exchange';
      case 'ACCEPT_MRB_REJECT':
        return 'MRB Reject';
      case 'ACCEPT_NO_MDD':
        return 'No MDD';
      case 'EXTENSIVE':
        return 'Extensive Repair';
      case 'STANDARD':
        return 'Standard Repair';
      case 'DEEP_DIVE_RETURNED_NFF':
        return 'Deep Dive, Returned NFF';
      case 'CLOSED_NO_ACTION':
        return 'Closed, No Action';
      default:
        return null;
    }
  }

}
